// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../../../node_modules/css-loader/index.js?minimize!../../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-b33daece\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./tag.vue");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../../../../node_modules/vue-style-loader/lib/addStylesClient.js")("d9b8d3f6", content, true);


//////////////////
// WEBPACK FOOTER
// /home/abuild/rpmbuild/BUILD/Portus-v2.3/~/vue-style-loader!/home/abuild/rpmbuild/BUILD/Portus-v2.3/~/css-loader?minimize!/home/abuild/rpmbuild/BUILD/Portus-v2.3/~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b33daece","scoped":true,"hasInlineConfig":false}!/home/abuild/rpmbuild/BUILD/Portus-v2.3/~/vue-loader/lib/selector.js?type=styles&index=0!./modules/repositories/components/tag.vue
// module id = 369
// module chunks = 0